import BaseService from "../../base/base_service";
import Model from "./game_manager_model";


class GameManagerService extends BaseService {
    /**
     * @static
     * @type {string}
     */

	static CLASS = 'GameManagerService';


		/**
		 * @property
		 * @type {null|object}
		 * @private
		 */
    _model = null;


		/**
		 *
		 * @param params
		 */
    init(params) {
		super.init(params);
		this._model = Model.create(params);
	}


    getNavbarProps() {
        return this._model.getNavbarProps();
    }

    cashierOpenType() {
        return this._model.getCashierOpenType();
    }

    responsibleGamblingView() {
        return this._model.getResponsibleGameView();
    }
}

export default GameManagerService;